// Guest chat on the staff side (docs/GUEST_CHAT_2026-10-28.md): presence
// check-in (guests see "online" while someone who answers chat has a screen
// open) and the unread badge. Who answers = chat.reply in the ONE catalog.
import { useEffect } from 'react';
import { api } from './api';
import { useLive } from './useLive';

export const CHAT_EVENTS = ['chat.message', 'chat.read', 'chat.closed', 'chat.reservation_created'];
const CHECK_IN_MS = 45000;

export function canChat(me) {
  return (me?.permissions || []).includes('chat.reply');
}

// Every 45 s while this tab is visible: "someone can answer".
export function useChatPresence(me) {
  const on = canChat(me);
  useEffect(() => {
    if (!on) return undefined;
    const ping = () => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      api.post('/dining/chat/presence').catch(() => {});
    };
    ping();
    const t = setInterval(ping, CHECK_IN_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') ping(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onVisible); };
  }, [on]);
}

export function useChatUnread(me) {
  const on = canChat(me);
  const live = useLive(() => api.get('/dining/chat/summary'), [], { enabled: on, types: CHAT_EVENTS });
  return on ? live.data?.unread_conversations || 0 : 0;
}
